import FormSetCoinsToUser from './FormSetCoinsToUser';
import { IHasErrorMessage } from '@/interfaces';
import { MainTabEnum } from './mainTab.enum';
import {
  BoostPackageNameEnum,
  CoinPackageNameEnum,
  IncognitoPackageNameEnum,
  ProductsEnum,
} from '@/enums';

export default FormSetCoinsToUser;
export { MainTabEnum } from './mainTab.enum';

export type TUser = {
  username: string;
  coins: number;
  id: string;
};

export type TFormData = IHasErrorMessage & {
  user: TUser;
  mainTab: MainTabEnum;
  comment?: string;
  product?: ProductsEnum;
  coinPackageName?: CoinPackageNameEnum;
  incognitoPackageName?: IncognitoPackageNameEnum;
  boostPackageName?: BoostPackageNameEnum;
};
